import { render } from "./SectionOptions.vue?vue&type=template&id=a0c30cb0&scoped=true&ts=true"
import script from "./SectionOptions.vue?vue&type=script&lang=ts"
export * from "./SectionOptions.vue?vue&type=script&lang=ts"

import "./SectionOptions.vue?vue&type=style&index=0&id=a0c30cb0&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0c30cb0"]])

export default __exports__